const unblockUserMapper = (response) => {
    if (response) {
        return { success: true };
    }
    return {};
};
export default unblockUserMapper;
